<template>
  <div>
    <p>{{ label }} participant's event block <strong>{{details.EventBlock.name}}</strong> (<a :href="link">Link</a>)</p>
    <ul class="list-unstyled object-details">
      <li><strong>Start date: </strong>{{ formatDate(details.start_date) }}</li>
    </ul>

  </div>
</template>

<script>
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat)

export default {
  name: "StudyUserEventBlock",
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('MMM Do YYYY [at] h:mma');
    }
  },
  computed: {
    link() {
      //TODO: This should actually check if it's an arm block first
      return `${this.$config.baseUrl}admin/study/${this.$config.studyId}/participants/${this.details.participant_id}/event#${this.details.id}`;
    }
  }
}
</script>

<style scoped>

</style>